export default __webpack_public_path__ + "static/media/topo.4e0daa1e.svg";